import { render, staticRenderFns } from "./PreK.vue?vue&type=template&id=5dc11b02&scoped=true&"
import script from "./PreK.vue?vue&type=script&lang=js&"
export * from "./PreK.vue?vue&type=script&lang=js&"
import style0 from "./PreK.vue?vue&type=style&index=0&id=5dc11b02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc11b02",
  null
  
)

export default component.exports